jQuery(document).ready(function ($) {

    // Add an event listener to the close button to close popups
    $('.popup-form .close-button').click(function () {
        $(this).closest('.popup-form').removeClass('is-active');
        $('body').removeClass('overflow-hidden');
    });

    // Add an event listener to the overlay background to close popups
    $('.overflowbg').click(function (event) {
        if ($(event.target).hasClass('overflowbg')) {
            $('.popup-form.is-active').removeClass('is-active');
            $('body').removeClass('overflow-hidden');
        }
    });

    // Add an event listener to the Escape key to close popups
    $(document).keydown(function (event) {
        if (event.key === 'Escape') {
            $('.popup-form.is-active').removeClass('is-active');
            $('body').removeClass('overflow-hidden');
        }
    });

});
